import type { Store } from 'effector'

import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { formatCategoryWithVodsToUi } from '~/entities/movies/lib'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'

export const $infiniteVodsFormatted = combine(
  api.vods.$infiniteVodsCategory,
  ssePurchasesModel.$vod,
  i18n.$t,
  (data, adjust, { t }) => formatCategoryWithVodsToUi(data, adjust, t)
)

export const $infiniteVodsTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('all')
)
